(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aura-chat-invitation"] && !Shopify.designMode) return;
  try {
    (() => {
  const panel = document.getElementById('aura-chat-invitation');
  if (!panel) return;
  const key = 'aura-chat-invitation-seen-v1';
  try { if (sessionStorage.getItem(key)) return; } catch (_) { /* Storage is optional. */ }
  const started = Date.now();
  let finished = false;
  let shown = false;
  const activator = () => document.querySelector('shopify-chat')?.shadowRoot?.querySelector('button[part~="activator"]');
  const remember = () => { try { sessionStorage.setItem(key, '1'); } catch (_) { /* Storage is optional. */ } };
  const position = button => {
    const rect = button.getBoundingClientRect();
    panel.style.left = `${Math.max(12, Math.min(rect.right - panel.offsetWidth, innerWidth - panel.offsetWidth - 12))}px`;
    panel.style.bottom = `${Math.max(12, Math.min(innerHeight - rect.top + 12, innerHeight - panel.offsetHeight - 12))}px`;
  };
  const dismiss = () => {
    finished = true;
    panel.hidden = true;
    remember();
    clearInterval(timer);
    window.removeEventListener('resize', resize);
    document.removeEventListener('click', manualOpen, true);
    document.removeEventListener('keydown', escape);
  };
  const resize = () => { const button = activator(); if (button && shown) position(button); };
  const manualOpen = event => { const button = activator(); if (button && event.composedPath().includes(button)) dismiss(); };
  const escape = event => {
    if (event.key === 'Escape' && !panel.hidden) {
      const hadFocus = panel.contains(document.activeElement);
      dismiss();
      if (hadFocus) activator()?.focus();
    }
  };
  panel.querySelector('.aura-chat-invitation__close').addEventListener('click', () => { dismiss(); activator()?.focus(); });
  panel.querySelector('.aura-chat-invitation__open').addEventListener('click', () => {
    const button = activator();
    dismiss();
    if (button && button.getAttribute('aria-expanded') !== 'true') button.click();
  });
  document.addEventListener('click', manualOpen, true);
  document.addEventListener('keydown', escape);
  window.addEventListener('resize', resize);
  const timer = setInterval(() => {
    if (finished) return;
    const button = activator();
    if (button?.getAttribute('aria-expanded') === 'true') { dismiss(); return; }
    if (!shown && Date.now() - started > 90000) { dismiss(); return; }
    const blocked = document.hidden || !button || button.getBoundingClientRect().width === 0 ||
      Array.from(document.querySelectorAll('dialog[open], details[open] [aria-modal="true"], cart-drawer.active, product-modal[open], modal-dialog[open], pickup-availability-drawer[open]')).some(el => el.getBoundingClientRect().width > 0 && getComputedStyle(el).visibility === 'visible' && (typeof el.checkVisibility !== 'function' || el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true })));
    if (blocked) { panel.hidden = true; return; }
    if (Date.now() - started < 20000) return;
    panel.hidden = false;
    shown = true;
    remember();
    position(button);
  }, 500);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aura-product-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aura-product-video')) {
    customElements.define('aura-product-video', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.video = this.querySelector('video');
        this.playButton = this.querySelector('.aura-video-play');
        this.soundButton = this.querySelector('.aura-video-sound');
        if (!this.video || !this.playButton || !this.soundButton) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.video.muted = true;
        this.video.playsInline = true;
        this.setAttribute('data-ready', '');
        this.sync = () => {
          this.toggleAttribute('data-playing', !this.video.paused && !this.video.ended);
          this.toggleAttribute('data-sound', !this.video.muted);
          const label = this.video.muted ? this.soundButton.dataset.unmute : this.soundButton.dataset.mute;
          this.soundButton.setAttribute('aria-label', label);
          this.soundButton.querySelector('span').textContent = label;
        };
        ['play', 'pause', 'ended', 'volumechange'].forEach(name => this.video.addEventListener(name, this.sync, options));
        this.playButton.addEventListener('click', () => {
          this.video.muted = false;
          this.playVideo();
        }, options);
        this.soundButton.addEventListener('click', () => {
          this.video.muted = !this.video.muted;
          this.sync();
          if (this.video.paused) this.playVideo();
        }, options);
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          this.inView = entry.isIntersecting && entry.intersectionRatio >= .35;
          if (this.inView) this.startAuto();
          else this.video.pause();
        }, { threshold: [0, .35] });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video.pause();
        }, options);
        this.sync();
      }
      startAuto() {
        if (!this.inView || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.video.muted = true;
        this.playVideo();
      }
      playVideo() {
        document.querySelectorAll('aura-product-video video').forEach(video => {
          if (video !== this.video) video.pause();
        });
        const attempt = this.video.play();
        if (attempt) attempt.catch(() => this.sync());
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.video?.pause();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
